import React from 'react';

interface WebixProps {
  ui: any;
  data?: any;
  select?: any;
}

class Webix extends React.Component<WebixProps> {
  private ui: any;
  private rootRef: React.RefObject<HTMLDivElement>;

  constructor(props: WebixProps) {
    super(props);
    this.rootRef = React.createRef();
  }

  componentDidMount() {
    const token = localStorage.getItem('token');
    const currentClient = localStorage.getItem('currentClient');



    (window as any).webix.attachEvent("onBeforeAjax", (mode: any, url: string, data: any, request: any, headers: any, files: any, promise: any) => {
      headers["Authorization"] = token ? `Bearer ${token}` : "";
      if (url.startsWith(process.env.REACT_APP_REPORTS_ENDPOINT || '')) {
        headers["X-Current-Client"] = currentClient || "ent";
      }
    });

    this.ui = (window as any).webix.ui(
        this.props.ui,
        this.rootRef.current
    );

    window.addEventListener("resize", () => {
      if (this.ui?.adjust) {
        this.ui.adjust();
      }
    });

    this.updateUI();
  }

  componentDidUpdate(prevProps: WebixProps) {
    if (
        prevProps.data !== this.props.data ||
        prevProps.select !== this.props.select
    ) {
      this.updateUI();
    }
  }

  componentWillUnmount() {
    this.ui = null;
    window.removeEventListener("resize", this.ui?.adjust);
  }

  updateUI() {
    const { data, select } = this.props;
    if (data) {
      this.setWebixData(data);
    }
    if (select) {
      this.select(select);
    }
  }

  setWebixData(data: any) {
    if (this.ui.setValues) {
      this.ui.setValues(data);
    } else if (this.ui.parse) {
      this.ui.parse(data);
    } else if (this.ui.setValue) {
      this.ui.setValue(data);
    }
  }

  select(select: any) {
    // Placeholder for future implementation
    console.warn('select method not implemented', select);
  }

  render() {
    return (
        <div ref={this.rootRef} style={{ width: '100%', height: '100%' }}></div>
    );
  }
}

export default Webix;